module.exports = __webpack_public_path__ + "static/img/job3.dfea200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/job3.png
// module id = Y7KR
// module chunks = 0